import React from 'react'
import Container from '../../../../../components/Container'
import { nameActions } from '../domain/info'
import { breadcrumbCreate } from '../domain/breadcrumb'
import { toolsCreate } from '../domain/tools'
import { FormCategory } from '../components/Form'

const Create: React.FC = () => {
  return (
    <>
      <Container
        pageTitle={nameActions.create.name}
        breadcrumb={breadcrumbCreate}
        tools={toolsCreate}
      >
        <div className="form body">
          <FormCategory typeForm="create" />
        </div>
      </Container>
    </>
  )
}
export default Create
